var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pb-2",attrs:{"color":"grey lighten-4"}},[_vm._v(" Maintenance ")])
}
var staticRenderFns = []

export { render, staticRenderFns }